/**
 * Liest die eigenen Berechtigungen (GET /permissions/me) und stellt sie als
 * hasPermission()-Check bereit. Admin/Super-Admin bekommen serverseitig
 * bereits alle Berechtigungen zurück (siehe apis/permissions/__init__.py),
 * hier also kein separater Admin-Sonderfall nötig.
 */
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

interface PermissionsResponse {
  permissions: string[];
  is_admin: boolean;
}

async function fetchPermissions(): Promise<PermissionsResponse> {
  const { data } = await api.get<PermissionsResponse>('/permissions/me');
  return data;
}

export function usePermissions() {
  const { data, isLoading } = useQuery<PermissionsResponse>({
    queryKey: ['permissions-me'],
    queryFn: fetchPermissions,
    staleTime: 5 * 60 * 1000, // Berechtigungen ändern sich selten, kein Live-Ticker nötig
  });

  const permissionSet = new Set(data?.permissions ?? []);

  return {
    isAdmin: data?.is_admin ?? false,
    // Solange nicht geladen: fail-closed, damit Buttons nicht kurz aufblitzen
    // und dann wieder verschwinden.
    hasPermission: (permission: string) => !isLoading && permissionSet.has(permission),
    isLoading,
  };
}
